// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/sections/About.css */
.about {
  padding: 100px 0;
  background: var(--dark-bg);
  position: relative;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 60px;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.about-text {
  margin-bottom: 40px;
}

.about-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: var(--text-secondary);
  margin-top: 30px;
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 60px;
}

.stat-card {
  background: rgba(26, 26, 26, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-primary);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.stat-card:hover::before {
  transform: scaleX(1);
}

.stat-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);
}

.stat-number {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 10px;
  line-height: 1;
}

.stat-label {
  font-size: 1rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.about-visual {
  position: relative;
  margin-top: 80px;
  display: flex;
  justify-content: center;
}

.visual-grid {
  display: grid;
  grid-template-columns: repeat(2, 150px);
  grid-template-rows: repeat(2, 150px);
  gap: 30px;
  position: relative;
}

.grid-item {
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}

.item-1 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);
}

.item-2 {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  box-shadow: 0 20px 40px rgba(0, 242, 254, 0.3);
}

.item-3 {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  box-shadow: 0 20px 40px rgba(250, 112, 154, 0.3);
}

.item-4 {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  box-shadow: 0 20px 40px rgba(168, 237, 234, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-4::after {
  content: 'ZZ';
  font-size: 3rem;
  font-weight: 800;
  color: white;
  opacity: 0.8;
}

/* Responsive */
@media (max-width: 768px) {
  .about-stats {
    grid-template-columns: 1fr;
    max-width: 300px;
    margin: 0 auto 60px;
  }
  
  .stat-card {
    padding: 30px 20px;
  }
  
  .stat-number {
    font-size: 2.5rem;
  }
  
  .visual-grid {
    grid-template-columns: repeat(2, 120px);
    grid-template-rows: repeat(2, 120px);
    gap: 20px;
  }
  
  .item-4::after {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .about-description {
    font-size: 1rem;
  }
  
  .visual-grid {
    grid-template-columns: repeat(2, 100px);
    grid-template-rows: repeat(2, 100px);
    gap: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sections/About.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;IACvC,oCAAoC;IACpC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uCAAuC;IACvC,oCAAoC;IACpC,SAAS;EACX;AACF","sourcesContent":["/* src/components/sections/About.css */\n.about {\n  padding: 100px 0;\n  background: var(--dark-bg);\n  position: relative;\n}\n\n.about-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 60px;\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.about-text {\n  margin-bottom: 40px;\n}\n\n.about-description {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: var(--text-secondary);\n  margin-top: 30px;\n}\n\n.about-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n  margin-bottom: 60px;\n}\n\n.stat-card {\n  background: rgba(26, 26, 26, 0.8);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 40px 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-primary);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.stat-card:hover::before {\n  transform: scaleX(1);\n}\n\n.stat-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);\n}\n\n.stat-number {\n  font-size: 3rem;\n  font-weight: 800;\n  margin-bottom: 10px;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.about-visual {\n  position: relative;\n  margin-top: 80px;\n  display: flex;\n  justify-content: center;\n}\n\n.visual-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 150px);\n  grid-template-rows: repeat(2, 150px);\n  gap: 30px;\n  position: relative;\n}\n\n.grid-item {\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.item-1 {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);\n}\n\n.item-2 {\n  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  box-shadow: 0 20px 40px rgba(0, 242, 254, 0.3);\n}\n\n.item-3 {\n  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\n  box-shadow: 0 20px 40px rgba(250, 112, 154, 0.3);\n}\n\n.item-4 {\n  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);\n  box-shadow: 0 20px 40px rgba(168, 237, 234, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.item-4::after {\n  content: 'ZZ';\n  font-size: 3rem;\n  font-weight: 800;\n  color: white;\n  opacity: 0.8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .about-stats {\n    grid-template-columns: 1fr;\n    max-width: 300px;\n    margin: 0 auto 60px;\n  }\n  \n  .stat-card {\n    padding: 30px 20px;\n  }\n  \n  .stat-number {\n    font-size: 2.5rem;\n  }\n  \n  .visual-grid {\n    grid-template-columns: repeat(2, 120px);\n    grid-template-rows: repeat(2, 120px);\n    gap: 20px;\n  }\n  \n  .item-4::after {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-description {\n    font-size: 1rem;\n  }\n  \n  .visual-grid {\n    grid-template-columns: repeat(2, 100px);\n    grid-template-rows: repeat(2, 100px);\n    gap: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
